import emotionReact_isolatedHnrs from "@emotion/react/_isolated-hnrs";
import { createSlice } from "@reduxjs/toolkit";

const stateSlice = createSlice({
  name: "rawMaterialList/state",
  initialState: {
    deleteConfirmation: false,
    selectedraw: "",
    selectedbom: {},
    selectedRawMaterial: [],
    selectedEditRawMaterial: {},
    newDialog: false,
    editDialog: false,
  },
  reducers: {
    toggleDeleteConfirmation: (state, action) => {
      state.deleteConfirmation = action.payload;
    },
    setSelectedRaw: (state, action) => {
      state.selectedEditRawMaterial = action.payload;
    },
    setSelectedBom: (state, action) => {
      state.selectedbom = action.payload;
    },

    addSelectedRawMaterial: (state, action) => {
      const index = state.selectedRawMaterial.findIndex(
        (item) =>
          item.Product?.product_id === action.payload.Product?.product_id
      );
      if (index >= 0) {
        state.selectedRawMaterial[index] = action.payload;
      } else {
        state.selectedRawMaterial = [
          ...state.selectedRawMaterial,
          action.payload,
        ];
      }
    },
    updateSelectedRawMaterial: (state, action) => {
      const index = state.selectedRawMaterial.findIndex(
        (item) =>
          item.Product?.product_id === action.payload.Product?.product_id
      );
      state.selectedRawMaterial[index] = action.payload;
      state.selectedEditRawMaterial = {};
    },
    toggleNewDialog: (state, action) => {
      state.newDialog = action.payload;
    },
    deleteSelectedRawMaterial: (state, action) => {
      state.selectedRawMaterial = state.selectedRawMaterial.filter(
        (item, index) => index !== action.payload
      );
    },
    emptySelectedRawMaterial: (state, action) => {
      state.selectedRawMaterial = action.payload;
    },
    toggleNewEditDialog: (state, action) => {
      state.editDialog = action.payload;
    },
    addBomDetail: (state, action) => {
      //  state.selectedRawMaterial=[];
      console.log(action.payload);
      state.selectedRawMaterial = [...action.payload];
    },
  },
});

export const {
  toggleDeleteConfirmation,
  setSelectedRaw,
  setSelectedBom,
  toggleNewDialog,
  addSelectedRawMaterial,
  updateSelectedRawMaterial,
  deleteSelectedRawMaterial,
  emptySelectedRawMaterial,
  toggleNewEditDialog,
  addBomDetail,
} = stateSlice.actions;

export default stateSlice.reducer;
